<!-- Page header -->
<div class="d-flex justify-content-between flex-wrap align-items-center pb-2 mb-3 border-bottom">
    <h2>Admin Dashboard</h2>
    <div class="btn-toolbar">
        <div class="btn-group me-2">
            <button type="button" class="btn btn-sm btn-outline-secondary">Share</button>
            <button type="button" class="btn btn-sm btn-outline-secondary">Export</button>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle">
            <i class="bi bi-calendar"></i>
            This Week
        </button>
    </div>
</div>

<!-- Dashboard content -->
<div class="row mb-4">
    <!-- Stats cards -->
    <div class="col mb-4">
        <div class="card border-left-primary h-100 py-2">
            <div class="card-body">
                <div class="row no-gutters align-items-center">
                    <div class="col">
                        <div class="text-xs fs-6 fw-bold text-primary text-uppercase mb-1">
                            Total Organizations
                        </div>
                        <div class="h5 mb-0 fw-bold">{{stats?.totalOrganizations}}</div>
                    </div>
                    <div class="col-auto">
                        <i class="bi bi-people fs-2 text-gray-300"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col mb-4">
        <div class="card border-left-primary h-100 py-2">
            <div class="card-body">
                <div class="row no-gutters align-items-center">
                    <div class="col">
                        <div class="text-xs fs-6 fw-bold text-info text-uppercase mb-1">
                            Total Departments
                        </div>
                        <div class="h5 mb-0 fw-bold">{{stats?.totalDepartments}}</div>
                    </div>
                    <div class="col-auto">
                        <i class="bi bi-people fs-2 text-gray-300"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col mb-4">
        <div class="card border-left-success h-100 py-2">
            <div class="card-body">
                <div class="row no-gutters align-items-center">
                    <div class="col">
                        <div class="text-xs fs-6 fw-bold text-success text-uppercase mb-1">
                            Total Service Areas
                        </div>
                        <div class="h5 mb-0 fw-bold">{{stats?.totalServiceAreas}}</div>
                    </div>
                    <div class="col-auto">
                        <i class="bi bi-diagram-3 fs-2 text-gray-300"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col mb-4">
        <div class="card border-left-info h-100 py-2">
            <div class="card-body">
                <div class="row no-gutters align-items-center">
                    <div class="col">
                        <div class="text-xs fs-6 fw-bold text-gray-300 text-uppercase mb-1">
                            Dept. Entry Completion
                        </div>
                        <div class="h5 mb-0 fw-bold">{{stats?.deptEntryCompletionRate}}</div>
                    </div>
                    <div class="col-auto">
                        <i class="bi bi-clipboard-check fs-2 text-gray-300"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col mb-4">
        <div class="card border-left-warning h-100 py-2">
            <div class="card-body">
                <div class="row no-gutters align-items-center">
                    <div class="col">
                        <div class="text-xs fs-6 fw-bold text-warning text-uppercase mb-1">
                            Pending Schedule Periods
                        </div>
                        <div class="h5 mb-0 fw-bold">{{stats?.pendingSchedulePeriodsCount}}</div>
                    </div>
                    <div class="col-auto">
                        <i class="bi bi-clock fs-2 text-gray-300"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Main content -->
<div class="row">


    <!-- Chart -->
    <!-- <div class="col mb-4">
        <div class="card shadow mb-4">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h6 class="m-0 fw-bold">Schedule Periods Activity by Organization</h6>
                <div class="dropdown">
                    <button class="btn btn-sm btn-light" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <i class="bi bi-three-dots-vertical"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                        <li><a class="dropdown-item" href="#">Export Data</a></li>
                        <li><a class="dropdown-item" href="#">Refresh</a></li>
                    </ul>
                </div>
            </div>
            <div class="card-body">
                <div class="chart-area">
                    <canvas baseChart [datasets]="schedulePeriodsDatasets" [labels]="schedulePeriodsLabels"
                        [chartOptions]="schedulePeriodsOptions" [chartType]="'line'" [legend]="true">
                    </canvas>
                </div>
            </div>
        </div>
    </div> -->

    <!-- Knowledge Base Items -->
    <div class="col mb-4">
        <div class="card shadow mb-4">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h6 class="m-0 fw-bold">Knowledge Base Items by Organization</h6>
                <div class="dropdown">
                    <button class="btn btn-sm btn-light" type="button" id="dropdownMenuButton2"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bi bi-three-dots-vertical"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton2">
                        <li><button class="dropdown-item" type="button">Export Data</button></li>
                        <li><button class="dropdown-item" type="button">Refresh</button></li>
                    </ul>
                </div>
            </div>
            <div class="card-body">
                <div class="chart-pie">
                    <canvas baseChart [datasets]="knowledgeBaseOrgDatasets" [labels]="knowledgeBaseOrgLabels"
                        [options]="knowledgeBaseOrgOptions" [type]="'bar'" [legend]="true">
                    </canvas>
                </div>
            </div>            
        </div>
    </div>


</div>

<!-- Table -->
<div class="row">
    <div class="col-12">
        <div class="card shadow mb-4">
            <div class="card-header py-3">
                <h6 class="m-0 fw-bold">Recent Schedule Periods</h6>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Department</th>
                                <th>Title</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let period of recentSchedulePeriods">
                                <td>{{period.departmentName}}</td>
                                <td>{{period.title}}</td>
                                <td>{{period.startDateTime | date:'yyyy-MM-dd'}}</td>
                                <td>{{period.endDateTime | date:'yyyy-MM-dd'}}</td>
                                <td>
                                    <span class="badge" [ngClass]="period.isApplied ? 'bg-success' : 'bg-warning'">
                                        {{period.isApplied ? 'Applied' : 'Pending'}}
                                    </span>
                                </td>
                                <td>
                                    <button class="btn btn-sm btn-primary" (click)="viewPeriod(period.id)">View</button>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>